// Canonical sidebar menu catalogue.
//
// Kept in a stand-alone module so Layout.jsx (which RENDERS the sidebar)
// and Settings.jsx ("Personalize menu" checkboxes) can share the same
// definitions — no drift between what shows in the nav and what the
// user can toggle.
//
// Each entry:
//   to        — route path (also used as the stable identifier for
//               `user.hidden_menu_items`).
//   labelKey  — i18n key when we translate; may be null.
//   labelEs   — Spanish label used as fallback / for the checkbox list.
//   section   — "op" | "catalog" | "management" | "admin"
//   roles     — array of role names allowed to SEE this item, OR "*" for
//               all authenticated users. `super_admin` is implicit — the
//               canonical super-admin-only items list it explicitly.
//
// The role filter always wins over the user preference. Dashboard ("/")
// is never hideable — it's the safety hatch back home.

export const MENU_ITEMS = [
  // OPERACIÓN
  { to: "/",                    labelEs: "Panel de Control",   section: "op",          roles: "*",                                     alwaysVisible: true },
  { to: "/nuevo-alquiler",      labelEs: "Nuevo Alquiler",     section: "op",          roles: "*" },
  { to: "/alquileres-activos",  labelEs: "Alquileres Activos", section: "op",          roles: "*" },
  { to: "/devoluciones",        labelEs: "Devoluciones",       section: "op",          roles: "*" },
  { to: "/caja",                labelEs: "Caja",               section: "op",          roles: "*" },
  { to: "/reservas-online",     labelEs: "Reservas Online",    section: "op",          roles: "*" },
  // CATÁLOGO
  { to: "/inventario",          labelEs: "Inventario",         section: "catalog",     roles: "*" },
  { to: "/tarifas",             labelEs: "Tarifas",            section: "catalog",     roles: ["admin", "super_admin"] },
  { to: "/mantenimiento",       labelEs: "Mantenimiento",      section: "catalog",     roles: "*" },
  // GESTIÓN
  { to: "/clientes",            labelEs: "Clientes",           section: "management",  roles: "*" },
  { to: "/proveedores",         labelEs: "Proveedores",        section: "management",  roles: "*" },
  { to: "/reportes",            labelEs: "Reportes",           section: "management",  roles: ["admin", "super_admin"] },
  // ADMIN
  { to: "/integraciones",       labelEs: "Integraciones",      section: "admin",       roles: ["admin", "super_admin"] },
  { to: "/configuracion",       labelEs: "Configuración",      section: "admin",       roles: ["admin", "super_admin"],                alwaysVisible: true },
  { to: "/equipo",              labelEs: "Gestión de Equipo",  section: "admin",       roles: ["admin", "super_admin"] },
  { to: "/tiendas",             labelEs: "Gestión de Tiendas", section: "admin",       roles: ["super_admin"] },
  { to: "/planes",              labelEs: "Planes",             section: "admin",       roles: ["super_admin"] },
  { to: "/salud-sistema",       labelEs: "Salud del Sistema",  section: "admin",       roles: ["super_admin"] },
];

export const SECTION_LABELS = {
  op: "Operación",
  catalog: "Catálogo",
  management: "Gestión",
  admin: "Admin",
};

export const SECTION_ORDER = ["op", "catalog", "management", "admin"];

/**
 * True when this item is visible for the given role.
 * `roles: "*"` → visible for every authenticated user.
 */
export function isItemAllowedForRole(item, role) {
  if (!role) return false;
  if (item.roles === "*") return true;
  return Array.isArray(item.roles) && item.roles.includes(role);
}
